/** Display regular discount + % for portal deal product option buttons */

export const getOptionLabel = (opt) => {
    if (!opt) return '';
    const w = opt.weight;
    if (typeof w === 'object' && w?.weightLabel) return String(w.weightLabel);
    if (typeof w === 'string') return w;
    return opt.optionName || 'default';
};

export const getOptionPriceHints = (opt) => {
    const regular = Number(opt?.discountPrice);
    const original = Number(opt?.originalPrice);
    const base = Number.isFinite(regular) && regular > 0 ? regular : original;
    let pct = null;
    if (Number.isFinite(original) && original > 0 && Number.isFinite(regular) && regular < original) {
        pct = Math.round(((original - regular) / original) * 100);
    }
    return {
        regularLabel: Number.isFinite(regular) && regular > 0 ? `₹${regular}` : null,
        pctLabel: pct != null && pct > 0 ? `${pct}% off` : null,
        basePrice: base,
    };
};
